import {
  BadgeDollarSign,
  BookOpenText,
  Circle,
  CircleDot,
  Droplets,
  Eye,
  Gem,
  Gift,
  HandHeart,
  Heart,
  Languages,
  Leaf,
  Magnet,
  MoonStar,
  Palette,
  Rainbow,
  Ruler,
  ShieldCheck,
  Sparkles,
  Sun,
  Waves,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import content from './site-content.json';

export type AtlasCard = Omit<(typeof content.atlasCards)[number], 'icon'> & {
  icon: LucideIcon;
};

export type MaterialGuide = Omit<(typeof content.materials)[number], 'icon'> & {
  href: string;
  icon: LucideIcon;
};

const iconMap: Record<string, LucideIcon> = {
  BadgeDollarSign,
  BookOpenText,
  Circle,
  CircleDot,
  Droplets,
  Eye,
  Gem,
  Gift,
  HandHeart,
  Heart,
  Languages,
  Leaf,
  Magnet,
  MoonStar,
  Palette,
  Rainbow,
  Ruler,
  ShieldCheck,
  Sparkles,
  Sun,
  Waves,
};

export const siteContent = content;

export const atlasCards: AtlasCard[] = content.atlasCards.map((card) => ({
  ...card,
  icon: iconMap[card.icon] || Gem,
}));

const verifiedMaterials = content.materials.filter(
  (material) => material.storeImageStatus === 'verified-store-product' && material.image.startsWith('/assets/store-products/'),
);

export const materialGuides: MaterialGuide[] = verifiedMaterials.map((material) => ({
  ...material,
  href: `/knowledge/${material.slug}`,
  icon: iconMap[material.icon] || Gem,
}));

export const ads = content.ads;

export const topicPages = content.topicPages;
